import { createQuery } from "@steto-care/steto-query";

import { ConfigRepository } from "@/io/repository/ConfigRepository.ts";

export class ConfigQueries {
  constructor(private readonly configRepository: ConfigRepository = new ConfigRepository()) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useSupportInfo = createQuery(
    "config",
    ({}) => [],
    async () => this.configRepository.getSupportInfo(),
  );
}
